import React, { useEffect, useState } from 'react';
import { FuelROB } from 'src/types/ViewModel/Bunkering/FuelROB';
import { FuelRobColumn } from 'src/types/ViewModel/Bunkering/FuelRobColumn';
import { RobRowStyle } from './BunkerRob.styles';
import { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { BunkerReceived } from 'src/types/ViewModel/Bunkering/BunkerReceived';
import { UUID } from 'crypto';
import FuelTransfer from './FuelTransfer';
import BunkerRobRow from './BunkerRobRow';
import { FuelRobVM } from 'src/types/ViewModel/Bunkering/FuelRobVM';
import { hasConsOrLossForTankAndBunkering } from '../BunkeringUtils';

interface BunkerRobTankProps {
    vm: FuelRobVM;
    tankId: number;
    previousColumn: FuelRobColumn;
    currentColumn: FuelRobColumn;
    fuelTanks?: Tank[];
    onChange: (changeObject: InputChangeData, rob: FuelROB, column: FuelRobColumn) => void;
    handleToggleSoundingVerified: (changeObject: InputChangeData, rob: FuelROB, column: FuelRobColumn) => void;
    onChangeDebunkering: (
        changeObject: InputChangeData,
        debunkerValue: BunkerReceived,
        column: FuelRobColumn,
        previousColumn: FuelRobColumn,
        oldValue: number
    ) => void;
    onTransferFuel: (column: FuelRobColumn, bunkeringGuid: UUID, fromTankId: number, toTankId: number, transferValue: number) => void;
}

const BunkerRobTank: React.FC<BunkerRobTankProps> = ({
    vm,
    tankId,
    previousColumn,
    currentColumn,
    fuelTanks,
    onChange,
    handleToggleSoundingVerified,
    onChangeDebunkering,
    onTransferFuel,
}) => {
    const [fuelTransferModal, setFuelTransferModal] = useState<boolean>(false);
    const [fuelTransferFromRob, setFuelTransferFromRob] = useState<FuelROB>(null);
    const [fuelRobsForTank, setFuelRobsForTank] = useState<FuelROB[]>([]);

    useEffect(() => {
        setFuelRobsForTank(
            currentColumn?.fuelRobs.filter((rob) => rob.tankId === tankId).sort((a, b) => a.bunkeringGuid.localeCompare(b.bunkeringGuid))
        );
    }, [currentColumn]);

    const openFuelTransferModal = (fromRob: FuelROB) => {
        setFuelTransferFromRob(fromRob);
        setFuelTransferModal(true);
    };

    const handleChangeDebunkering = (changeObject: InputChangeData, debunkerValue: BunkerReceived, column: FuelRobColumn, oldValue: number) => {
        onChangeDebunkering(changeObject, debunkerValue, column, previousColumn, oldValue);
    };

    if (!fuelRobsForTank || fuelRobsForTank.length === 0) {
        return <RobRowStyle key={`${tankId}_rob`} indent></RobRowStyle>;
    }

    return (
        <div>
            {fuelTransferModal && (
                <FuelTransfer
                    fuelTanks={fuelTanks}
                    tankId={tankId}
                    currentColumn={currentColumn}
                    fuelTransferFromRob={fuelTransferFromRob}
                    onTransferFuel={onTransferFuel}
                    closeTransferModal={() => setFuelTransferModal(false)}
                    setFuelTransferFromRob={setFuelTransferFromRob}
                />
            )}
            {fuelRobsForTank.map((rob, i) => (
                <BunkerRobRow
                    key={`${tankId}_${rob.bunkeringGuid}_${rob?.noonReportId}_rob_${i}`}
                    i={i}
                    tank={fuelTanks.find((tank) => tank.tankId === tankId)}
                    rob={rob}
                    fuelRobsForTank={fuelRobsForTank}
                    previousColumn={previousColumn}
                    currentColumn={currentColumn}
                    hasConsumption={hasConsOrLossForTankAndBunkering(tankId, rob.bunkeringGuid, vm)}
                    onChangeRob={onChange}
                    onToggleSoundingsVerified={handleToggleSoundingVerified}
                    onChangeDebunkering={handleChangeDebunkering}
                    openFuelTransferModal={openFuelTransferModal}
                />
            ))}
        </div>
    );
};

export default BunkerRobTank;
